export const USER_BALANCE = 'USER_BALANCE';